import React , {Component} from 'react';
import Skeleton from 'react-loading-skeleton';
class ArticleLoader extends Component{
    render(){
        return(
            <div>
                <div className="row">
                    <div className="col">
                        <Skeleton count={1} height={100}/>
                    </div>
                </div>
                <div className="row mt-3">
                    <div className="col">
                        <Skeleton count={1} height={100}/>
                    </div>
                </div>
                <div className="row mt-3">
                    <div className="col">
                        <Skeleton count={1} height={100}/>
                    </div>
                </div>
                <div className="row mt-3">
                    <div className="col">
                        <Skeleton count={1} height={100}/>
                    </div>
                </div>
                <div className="row mt-3">
                    <div className="col">
                        <Skeleton count={1} height={100}/>
                    </div>
                </div>
            </div>

        )
    }
}


export default ArticleLoader;